import React, { useEffect, useState } from "react";
import { useParams, useLocation, useOutletContext } from "react-router-dom";
import { FileIcon, AddIcon } from "../../../icons";

import GlobalLoader from "../../common/GlobalLoader";
import DeleteConfirmPopUp from "../../common/deleteConfirmPopUp";
import {
  getMaterialsByFolder,
  createMaterial,
  updateMaterial,
  deleteMaterial,
} from "../../../helper/apicalls/materials";
import {
  getAdminMaterialsInInstitution,
  createMaterialInstitution,
  updateMaterialInstitution,
  deleteMaterialInstitution,
  getMaterialsInstitution,
} from "../../../helper/apicalls/institution/materials";
import CreateMaterialPopup from "../../common/CreateMaterialPopup";
import ViewMaterialPopup from "../../common/ViewMaterialPopup";
import "./../../../styles/admin/questionBank.scss";
import pdfIcon from "../../../assets/svg/pdfIcon.svg";
import playIcon from "../../../assets/png/playIcon.png";
import audioIcon from "../../../assets/png/audioIcon.png";
import imgIcon from "../../../assets/png/imgIcon.png";
import powerpointIcon from "../../../assets/png/powerpointIcon.png";
import Cookies from "js-cookie";

const MaterialsFolderPage = () => {
  const { folderId } = useParams();
  const location = useLocation();
  const { setHeaderName } = useOutletContext();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [editMaterial, setEditMaterial] = useState(null);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [materialToDelete, setMaterialToDelete] = useState(null);
  const [viewMaterial, setViewMaterial] = useState(null);

  const role = Cookies.get("role");
  const state = location.state || {};
  const isFolderAdmin = (role === "institution" || role === "teacher") && (state.is_admin || false);
  const permissions = Cookies.get("permissions");
  const permissionsData = permissions ? JSON.parse(permissions) : [];
  const materialPermission = Array.isArray(permissionsData)
    ? permissionsData.find((p) => p?.permission_type === "material")
    : null;
  const hasWritePermission =
    role === "admin" || (materialPermission ? !!materialPermission.write : false);

  const renderMaterialIcon = (item) => {
    const type = (item?.materials_type || "").toLowerCase();
    if (type === "pdf") {
      return (
        <img
          src={pdfIcon}
          alt="PDF Icon"
          style={{ width: "48px", height: "48px", marginTop: "4px" }}
        />
      );
    }
    if (type === "video" || type === "videos") {
      return (
        <img
          src={playIcon}
          alt="Video Icon"
          style={{ width: "48px", height: "48px", marginTop: "4px" }}
        />
      );
    }
    if (type === "audio") {
      return (
        <img
          src={audioIcon}
          alt="Audio Icon"
          style={{ width: "48px", height: "48px", marginTop: "4px" }}
        />
      );
    }
    if (type === "img" || type === "image" || type === "images") {
      return (
        <img
          src={imgIcon}
          alt="Image Icon"
          style={{ width: "48px", height: "48px", marginTop: "4px" }}
        />
      );
    }
    if (type === "powerpoint" || type === "ppt" || type === "pptx") {
      return (
        <img
          src={powerpointIcon}
          alt="PowerPoint Icon"
          style={{ width: "48px", height: "48px", marginTop: "4px" }}
        />
      );
    }
    return <FileIcon style={{ color: "var(--text-secondary)" }} />;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const role = Cookies.get("role");
        let data;

        if (role === "institution" || role === "teacher") {
          if (isFolderAdmin) {
            data = await getAdminMaterialsInInstitution({
              materials_folders: folderId,
            });
          } else {
            data = await getMaterialsInstitution({
              materials_folders: folderId,
            });
          }
        } else {
          data = await getMaterialsByFolder(folderId);
        }

        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching materials for folder:", err);
        setError("Failed to fetch materials");
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    if (folderId) {
      fetchData();
    }
  }, [folderId]);

  useEffect(() => {
    const state = location.state || {};
    setHeaderName(`Materials - ${state.folderName || "Folder"}`);
  }, [location.state]);

  useEffect(() => {
    if (!menuOpenId) return;

    const handleClickOutside = (event) => {
      const menus = document.querySelectorAll(
        ".folder-menu, .folder-menu-button",
      );
      for (let i = 0; i < menus.length; i += 1) {
        const el = menus[i];
        if (el && el.contains(event.target)) {
          return;
        }
      }

      setMenuOpenId(null);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpenId]);

  return (
    <>
      <GlobalLoader visible={loading} text="Loading..." />
      <div className="question-bank-container">
        <div className="qb-card">
          <div className="qb-card-header">
            <span>Folder Materials</span>
            <div className="qb-card-actions">
              {!isFolderAdmin && hasWritePermission && (
                <button
                  type="button"
                  className="qb-add-btn"
                  onClick={() => setShowCreatePopup(true)}
                >
                  <AddIcon className="action-button-icon" />
                  <span>Add Material</span>
                </button>
              )}
            </div>
          </div>
          <div className="folder-grid">
            {!loading &&
              !error &&
              items?.map((m) => {
                const id = m.id;
                return (
                  <div
                    key={id}
                    className="folder-item file-item"
                    onClick={() => setViewMaterial(m)}
                  >
                    <div className="folder-icon">{renderMaterialIcon(m)}</div>
                    <div className="folder-name">{m.name || id}</div>
                    {isFolderAdmin && (
                      <div className="qb-default-badge">Default</div>
                    )}
                    {!isFolderAdmin && hasWritePermission && (
                      <button
                        type="button"
                        className="folder-menu-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpenId((prev) => (prev === id ? null : id));
                        }}
                      >
                        ⋮
                      </button>
                    )}
                    {menuOpenId === id && (
                      <div
                        className="folder-menu"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="folder-menu-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setEditMaterial(m);
                            setMenuOpenId(null);
                          }}
                        >
                          Edit
                        </div>
                        <div
                          className="folder-menu-item --danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            setMaterialToDelete(m);
                            setIsConfirmDeleteOpen(true);
                            setMenuOpenId(null);
                          }}
                        >
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}

            {error && <div className="qb-error">{error}</div>}
          </div>
        </div>
      </div>

      {showCreatePopup && (
        <CreateMaterialPopup
          open={showCreatePopup}
          handleClose={() => setShowCreatePopup(false)}
          folderId={folderId}
          onSave={async (payload, file) => {
            try {
              setLoading(true);

              const role = Cookies.get("role");
              if (role === "institution" || role === "teacher") {
                const state = location.state || {};
                const isFolderAdmin = state.is_admin || false;

                if (isFolderAdmin) {
                  await createMaterialInstitution(payload, file);
                } else {
                  await createMaterialInstitution(payload, file);
                }
              } else {
                await createMaterial(payload, file);
              }

              let data;
              if (role === "institution" || role === "teacher") {
                if (isFolderAdmin) {
                  data = await getAdminMaterialsInInstitution({
                    materials_folders: folderId,
                  });
                } else {
                  data = await getMaterialsInstitution({
                    materials_folders: folderId,
                  });
                }
              } else {
                data = await getMaterialsByFolder(folderId);
              }
              setItems(Array.isArray(data) ? data : []);
              setShowCreatePopup(false);
            } catch (err) {
              console.error("Error creating material:", err);
              setError("Failed to create material");
            } finally {
              setLoading(false);
            }
          }}
        />
      )}

      {editMaterial && (
        <CreateMaterialPopup
          open={!!editMaterial}
          handleClose={() => setEditMaterial(null)}
          folderId={folderId}
          material={editMaterial}
          materialId={editMaterial?.id}
          mode="edit"
          onSave={async (payload, file) => {
            try {
              setLoading(true);

              const { materials_folders, ...updatePayload } = payload || {};

              const role = Cookies.get("role");
              if (role === "institution" || role === "teacher") {
                const state = location.state || {};
                const isFolderAdmin = state.is_admin || false;

                if (isFolderAdmin) {
                  await updateMaterialInstitution(
                    editMaterial?.id,
                    updatePayload,
                    file,
                  );
                } else {
                  await updateMaterialInstitution(
                    editMaterial?.id,
                    updatePayload,
                    file,
                  );
                }
              } else {
                await updateMaterial(editMaterial?.id, updatePayload, file);
              }

              let data;
              if (role === "institution" || role === "teacher") {
                if (isFolderAdmin) {
                  data = await getAdminMaterialsInInstitution({
                    materials_folders: folderId,
                  });
                } else {
                  data = await getMaterialsInstitution({
                    materials_folders: folderId,
                  });
                }
              } else {
                data = await getMaterialsByFolder(folderId);
              }
              setItems(Array.isArray(data) ? data : []);
            } catch (err) {
              console.error("Error updating material:", err);
              setError("Failed to update material");
            } finally {
              setLoading(false);
              setEditMaterial(null);
            }
          }}
        />
      )}

      {isConfirmDeleteOpen && (
        <DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmDeleteOpen}
          setIsConfirmDeleteOpen={setIsConfirmDeleteOpen}
          title="Delete material"
          message={`Are you sure you want to delete the material "${
            materialToDelete?.name || ""
          }"? This action cannot be undone.`}
          confirmLabel="Delete"
          cancelLabel="Cancel"
          handleDelete={async () => {
            if (!materialToDelete?.id) {
              setIsConfirmDeleteOpen(false);
              return;
            }
            try {
              setLoading(true);

              const role = Cookies.get("role");
              if (role === "institution" || role === "teacher") {
                const state = location.state || {};
                const isFolderAdmin = state.is_admin || false;

                if (isFolderAdmin) {
                  await deleteMaterialInstitution(materialToDelete.id);
                } else {
                  await deleteMaterialInstitution(materialToDelete.id);
                }
              } else {
                await deleteMaterial(materialToDelete.id);
              }

              let data;
              if (role === "institution" || role === "teacher") {
                if (isFolderAdmin) {
                  data = await getAdminMaterialsInInstitution({
                    materials_folders: folderId,
                  });
                } else {
                  data = await getMaterialsInstitution({
                    materials_folders: folderId,
                  });
                }
              } else {
                data = await getMaterialsByFolder(folderId);
              }
              setItems(Array.isArray(data) ? data : []);
            } catch (e) {
              console.error("Error deleting material:", e);
              setError("Failed to delete material");
            } finally {
              setLoading(false);
              setIsConfirmDeleteOpen(false);
              setMaterialToDelete(null);
            }
          }}
        />
      )}

      {viewMaterial && (
        <ViewMaterialPopup
          open={!!viewMaterial}
          handleClose={() => setViewMaterial(null)}
          material={viewMaterial}
        />
      )}
    </>
  );
};

export default MaterialsFolderPage;
